import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Alert,
  CircularProgress,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import { CheckCircle, Error } from "@mui/icons-material";

const OAuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading"
  );
  const [message, setMessage] = useState<string>("");

  useEffect(() => {
    const calendarConnected = searchParams.get("calendar_connected");
    const calendarError = searchParams.get("calendar_error");
    const message = searchParams.get("message");

    if (calendarConnected === "true") {
      setStatus("success");
      setMessage("Google Calendar connected successfully!");
      
    } else if (calendarError === "true") {
      setStatus("error");
      setMessage("Failed to connect Google Calendar");
      console.error("OAuth Error");
    } else {

      const success = searchParams.get("success");
      const error = searchParams.get("error");

      if (success === "true") {
        setStatus("success");
        setMessage(message || "Google Calendar connected successfully!");
        
      } else if (error === "true") {
        setStatus("error");
        setMessage(message || "Failed to connect Google Calendar");
        console.error("OAuth Error:", message);
      } else {
        setStatus("error");
        setMessage("Invalid OAuth callback response");
      }
    }
  }, [searchParams]);

  const handleGoBack = () => {
    navigate("/admin/scheduling-management");
  };

  if (status === "loading") {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="50vh"
        gap={2}
      >
        <CircularProgress />
        <Typography variant="h6">Processing OAuth callback...</Typography>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="50vh"
      p={3}
    >
      <Card sx={{ maxWidth: 500, width: "100%" }}>
        <CardContent>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={3}
          >
            {status === "success" ? (
              <CheckCircle color="success" sx={{ fontSize: 60 }} />
            ) : (
              <Error color="error" sx={{ fontSize: 60 }} />
            )}

            <Typography variant="h5" textAlign="center">
              {status === "success" ? "Success!" : "Error"}
            </Typography>

            <Alert
              severity={status === "success" ? "success" : "error"}
              sx={{ width: "100%" }}
            >
              <Typography variant="body1">{message}</Typography>
            </Alert>

            <Button variant="contained" onClick={handleGoBack} sx={{ mt: 2 }}>
              Back to Scheduling Management
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OAuthCallback;
